import React, { useEffect, useState } from 'react'
import { Card, Select, Button } from 'antd'
import { ArrowLeftOutlined, InfoCircleOutlined } from '@ant-design/icons'
import { useNavigate, useParams } from 'react-router-dom'
import { useMasterData } from '@/context/MasterDataContext'
import { mappingStore } from './mappingStore'
import ConsumerAllocationEditor from './ConsumerAllocationEditor'

const MappingForm: React.FC = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const isEditing = !!id

  const { generators: masterGenerators } = useMasterData()

  const generatorOptions = masterGenerators
    .filter(g => g.status === 'active')
    .map(g => ({ label: `${g.name} (${g.code})`, value: g.id }))

  const [genId, setGenId] = useState<string>('')

  // When editing, the generator is fixed by the existing group.
  useEffect(() => {
    if (!id) return
    const existing = mappingStore.get(id)
    if (existing) setGenId(existing.generatorId)
  }, [id])

  return (
    <div>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/mappings')} />
        <div>
          <h2 className="page-title">{isEditing ? 'Edit Group Mapping' : 'Map Consumers to Plant'}</h2>
          <p className="page-subtitle">Select a generator, then pick a plant and add consumers with allocation % and units</p>
        </div>
      </div>

      {/* Step 1: Generator */}
      <Card title={<span style={{ fontWeight: 700 }}>Step 1 — Select Generator</span>} style={{ marginBottom: 16 }}>
        <div style={{ maxWidth: 520 }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: '#4A5568', marginBottom: 6 }}>Generator</div>
          <Select
            placeholder="Select generator..."
            options={generatorOptions}
            value={genId || undefined}
            disabled={isEditing}
            showSearch optionFilterProp="label"
            style={{ width: '100%' }}
            onChange={(val) => setGenId(val)}
          />
          {isEditing && (
            <div style={{ marginTop: 6, fontSize: 11.5, color: '#8A93A6', display: 'flex', alignItems: 'center', gap: 6 }}>
              <InfoCircleOutlined /> Generator is fixed while editing an existing group.
            </div>
          )}
        </div>
      </Card>

      {/* Step 2: Plant + Consumers (shared editor) */}
      {genId && (
        <Card title={<span style={{ fontWeight: 700 }}>Step 2 — Select Plant &amp; Add Consumers</span>}>
          <ConsumerAllocationEditor
            key={`${genId}-${id ?? 'new'}`}
            generatorId={genId}
            mappingId={id}
            onSaved={() => navigate('/mappings')}
            onCancel={() => navigate('/mappings')}
          />
        </Card>
      )}
    </div>
  )
}

export default MappingForm
